import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventoService {
  urls: { [key: string]: string } = environment.urlsApi;

  constructor(private http: HttpClient, private router: Router) {}

  private getHeaders(): { headers: HttpHeaders } {
    const token = localStorage.getItem('auth_token');
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    });
    headers = headers.set('Authorization', `Bearer ${token}`);

    return { headers };
  }

  saveInscripcion(
    obj: { evento_user_uuid: string; evento: number },
    vc_uuid: string
  ): Observable<Object[]> {

    return this.http
      .post<Object[]>(`${this.urls['eventos']}/events/${vc_uuid}/eventInscripcion`, obj, this.getHeaders())
      .pipe(map((response) => response as Object[]));
  }

  getEventInscrito(obj: { uuid: number; evento: string },) {
    return this.http
      .post<Object[]>(`${this.urls['eventos']}/events/${obj.evento}/detailInscrito`, obj, this.getHeaders())
      .pipe(map((response) => response as Object[]));
  }


  deleteInscripcionEvent(
    obj: { evento_user_uuid: string; evento: number },
    vc_uuid: string
  ): Observable<Object[]> {
    return this.http
      .post<Object[]>(`${this.urls['eventos']}/events/${vc_uuid}/eventInscripcionDelete`, obj, this.getHeaders())
      .pipe(map((response) => response as Object[]));
  }

  //Ofertas 

    saveInscripcionOffer(
    obj: { offer_user_uuid: string; offer: number },
    vc_uuid: string
  ): Observable<Object[]> {

    return this.http
      .post<Object[]>(`${this.urls['eventos']}/offers/${vc_uuid}/offerInscripcion`, obj, this.getHeaders())
      .pipe(map((response) => response as Object[]));
  }

  getOfferInscrito(obj: { uuid: number; offer: string },) {
    return this.http
      .post<Object[]>(`${this.urls['eventos']}/offers/${obj.offer}/detailInscrito`, obj, this.getHeaders())
      .pipe(map((response) => response as Object[]));
  }

  deleteInscripcionOffer(
    obj: { offer_user_uuid: string; offer: number },
    vc_uuid: string
  ): Observable<Object[]> {
    return this.http
      .post<Object[]>(`${this.urls['eventos']}/offers/${vc_uuid}/offerInscripcionDelete`, obj, this.getHeaders())
      .pipe(map((response) => response as Object[]));
  }
}
